import { useState, useEffect } from 'react'
import cx from 'classnames'
import Foco from 'react-foco'
import { Field } from 'formik'
import Styles from '../PropertyForm.module.scss'
import { ReactComponent as Cheveron } from '../../PropertyValue/icons/cheveron-down-small__16.svg'
import { type Values as FormValues } from '../PropertyForm'

interface Props {
  values: FormValues
  isEdit: boolean
  isValid: boolean
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}

// NOTE: if you modify this enum, don't forget to also modify its counterpart in
// https://github.com/almanaclabs/almanac-on-rails/blob/master/app/models/property.rb
// TODO: have a single source of truth
export enum NumberFormat {
  Integer = 'integer',
  Decimal1 = 'decimal1',
  Decimal2 = 'decimal2',
  Decimal3 = 'decimal3',
}

const numberFormats: { [key in NumberFormat]: string } = {
  [NumberFormat.Integer]: 'Integer (1)',
  [NumberFormat.Decimal1]: 'Decimal (1.0)',
  [NumberFormat.Decimal2]: 'Decimal (1.00)',
  [NumberFormat.Decimal3]: 'Decimal (1.000)',
}

const Number = ({ isEdit, isValid, setFieldValue, values }: Props) => {
  const {
    meta: { number_format },
  } = values
  const [formatDropdownOpen, setFormatDropdownOpen] = useState(false)
  const [selectedFormat, setSelectedFormat] = useState<NumberFormat>(
    number_format && isEdit ? number_format : NumberFormat.Integer,
  )

  useEffect(() => {
    setFieldValue('meta.number_format', selectedFormat)
  }, [selectedFormat, setFieldValue])

  const formatSelect = () => (
    <div className={Styles.formSelectContainer}>
      <div onClick={() => setFormatDropdownOpen(true)} className={cx(Styles.formInput, Styles.formSelect)}>
        <Field
          id="number_format"
          type="text"
          name="meta.number_format"
          placeholder="format"
          value={numberFormats[selectedFormat]}
        />
        <Cheveron className={Styles.cheveronIcon} />
      </div>
      {formatDropdownOpen && (
        <Foco onClickOutside={() => setFormatDropdownOpen(false)}>
          <div className={Styles.containerPrompt}>
            <div className={Styles.resultsList}>
              {Object.entries(numberFormats).map(([formatKey, formatValue], index) => (
                <li
                  className={Styles.resultListItem}
                  onClick={() => {
                    setSelectedFormat(formatKey as NumberFormat)
                    setFormatDropdownOpen(false)
                  }}
                  key={index}
                >
                  {formatValue}
                </li>
              ))}
            </div>
          </div>
        </Foco>
      )}
    </div>
  )
  return (
    <div className={Styles.textSubsection}>
      <div className={Styles.sectionSubheader}>A property that you can set with any numeric value.</div>
      <div className={Styles.sectionHeader}>Format</div>
      {formatSelect()}
    </div>
  )
}

export default Number
